module.exports = __webpack_public_path__ + "static/media/Cam.a0202066.png";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Cam/Cam.png
// module id = 199
// module chunks = 0